import { z } from 'zod'

/**
 * Champs texte du dépôt public d'ordonnance (`POST public/care/ordonnance`, multipart).
 *
 * Sans compte, nom, prénom et date de naissance sont obligatoires : l'API répond 422 sinon. Avec
 * un jeton patient, l'identité vient du compte et ces champs restent absents.
 */
export const publicOrdonnanceDepositSchema = z.union([
  z.object({ cip: z.string().trim().min(1) }).strict(),
  z
    .object({
      cip: z.string().trim().min(1),
      lastname: z.string().trim().min(1),
      firstname: z.string().trim().min(1),
      birthdate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    })
    .strict(),
])

export type PublicOrdonnanceDepositFields = z.infer<typeof publicOrdonnanceDepositSchema>
